import { useCallback, useEffect } from "react";
import appHistory from "../../../app/appHistory";

function useLocationEventListener() {
    const eventListener = useCallback((message: MessageEvent) => {
        try {
            if (!message.data) return;
            const data = typeof message.data === 'object' ? message.data : JSON.parse(message.data);
            const type = data.type;
            const path = data.path;
            if (type === 'location' && path) {
                appHistory.push(path);
            }
        } catch (e) {
            // Wrong message
        }
    }, []);

    useEffect(() => {
        window.addEventListener('message', eventListener);
        document.addEventListener('message', eventListener);
        return () => {
            window.removeEventListener('message', eventListener);
            document.removeEventListener('message', eventListener);
        }
    }, [eventListener]);
}

export default useLocationEventListener;
